import { useUsers } from 'hooks/useUsers.hooks'
import UsersDataGrid from '../view-users/UsersDataGrid'
import { Button, Grid } from '@mui/material'
import { Link } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';


const AdminArchivedRecipientScreen = function() {
  const usersState = useUsers('Recipient', false)
  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
      <Button variant="contained" component={Link} to='/recipients'>
          Return to Active Recipients
      </Button>
      </Grid>
      
      <Grid item xs={12}>
      <MainCard title="Archived Recipients">
      {!usersState.ready ? (
        <div>Loading</div>
      ) : (
        <UsersDataGrid
          role="Recipient"
          active={false}
        />
      )}
      </MainCard>
      </Grid>
    </Grid>
  )
}

export default AdminArchivedRecipientScreen